import { Box, Button, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Icons } from "./../Icons";
import moment from "moment";
import ModalTrazabilidad from "./../ModalTrazabilidad";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
  rows: any[]; // 🔥 IMPORTANTE: Ahora recibes rows
}

const getColumnsSolicitudAE = ({
  handleVerClick,
  urlOrigen,
  rows
}: ColumnsProps): GridColDef[] => {
  const formatNumber = (value: any) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const columns: GridColDef[] = [
    {
      field: "Municipio",
      headerName: "Municipios",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (cellValues: any) => {
        return <p>{cellValues.row.Municipio}</p>;
      },
    },
    {
      field: "FOULT",
      headerName: "Fondo de Ultracrecimiento Municipal",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FOULT)}</p>;
      },
    },
    {
      field: "FODES",
      headerName: "Fondos Descentralizados",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FODES)}</p>;
      },
    },
    {
      field: "FOSEGMUN",
      headerName: "Fondos de Seguridad para los Municipios",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FOSEGMUN)}</p>;
      },
    },
    {
      field: "FOINMUN",
      headerName: "Fondo de Infraestructura para los Municipios",
      width: 300,
      hideable: false,
      headerAlign: "left",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FOINMUN)}</p>;
      },
    },
    {
      field: "TOTALES",
      headerName: "TOTALES",
      width: 250,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.TOTALES)}</p>;
      },
    },

  ];
  const filteredColumns = columns.filter((col) => {
    // "municipio" siempre aparece
    if (col.field === "municipio") return true;

    // ¿Hay algún valor numérico distinto de cero?
    return rows.some((row) => {
      const raw = row[col.field];

      // vacío, null o undefined ⇒ descartar esta fila
      if (raw === undefined || raw === null || raw === "") return false;

      // si es string, intentar parsear como número (quita comas)
      const num =
        typeof raw === "string" ? parseFloat(raw.replace(/,/g, "")) : raw;

      // si no es número (NaN), considérese valor “significativo”
      if (isNaN(num)) return true;

      // incluir columna si al menos un número es distinto de cero
      return num !== 0;
    });
  });

  return filteredColumns;
};

export default getColumnsSolicitudAE;
